namespace AgerLMS.LMS {
    export interface QuizQuestionRow {
        Id?: number;
        QuizId?: number;
        PreQuestion1?: string;
        QuestionImage1?: string;
        Question?: string;
        ChoiceA?: string;
        ChoiceB?: string;
        ChoiceC?: string;
        ChoiceD?: string;
        ChoiceE?: string;
        CorrectAnswer?: QuestionChoices;
        Grade?: number;
        DisplayOrder?: number;
        QuizCourseId?: number;
        QuizSectionId?: number;
        QuizQuizTitle?: string;
        QuizTime?: number;
        QuizNumberOfAttemps?: number;
        QuizPassMark?: number;
        QuizIsActive?: number;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace QuizQuestionRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Question';
        export const localTextPrefix = 'LMS.QuizQuestion';
        export const deletePermission = 'LMS:QuizQuestion:Modify';
        export const insertPermission = 'LMS:QuizQuestion:Modify';
        export const readPermission = 'LMS:QuizQuestion:Read';
        export const updatePermission = 'LMS:QuizQuestion:Modify';

        export declare const enum Fields {
            Id = "Id",
            QuizId = "QuizId",
            PreQuestion1 = "PreQuestion1",
            QuestionImage1 = "QuestionImage1",
            Question = "Question",
            ChoiceA = "ChoiceA",
            ChoiceB = "ChoiceB",
            ChoiceC = "ChoiceC",
            ChoiceD = "ChoiceD",
            ChoiceE = "ChoiceE",
            CorrectAnswer = "CorrectAnswer",
            Grade = "Grade",
            DisplayOrder = "DisplayOrder",
            QuizCourseId = "QuizCourseId",
            QuizSectionId = "QuizSectionId",
            QuizQuizTitle = "QuizQuizTitle",
            QuizTime = "QuizTime",
            QuizNumberOfAttemps = "QuizNumberOfAttemps",
            QuizPassMark = "QuizPassMark",
            QuizIsActive = "QuizIsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
